import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function MentionsLegalesPage() {
  const pageTitle = 'Mentions légales | Léger\'s Coffee'
  const pageDescription =
    'Consultez les mentions légales du site Léger\'s Coffee : éditeur, hébergement, propriété intellectuelle, données personnelles et contact.'

  return (
    <>
      <Helmet>
        <html lang="fr" />
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://legerscoffee.fr/mentions-legales" />
      </Helmet>

      <main data-testid="mentions-legales-page" className="min-h-screen pt-20 bg-warm-alabaster">
        <section className="bg-warm-secondary py-12 lg:py-16">
          <div className="max-w-5xl mx-auto px-6 lg:px-12">
            <span className="text-latte-gold text-sm uppercase tracking-widest font-medium mb-4 block">
              Informations légales
            </span>
            <h1 className="font-serif text-3xl lg:text-4xl text-espresso font-semibold">
              Mentions légales
            </h1>
            <p className="text-soft-charcoal-secondary mt-3 max-w-3xl leading-relaxed">
              Vous trouverez ci-dessous les informations légales relatives au site Léger&apos;s Coffee,
              à son éditeur, à son hébergement, ainsi qu’aux règles applicables à son utilisation.
            </p>
          </div>
        </section>

        <section className="py-12 lg:py-16">
          <div className="max-w-5xl mx-auto px-6 lg:px-12">
            <div className="bg-white border border-border-subtle p-6 lg:p-10 space-y-10">
              <section>
                <h2 className="font-serif text-2xl text-espresso font-semibold mb-4">
                  1. Éditeur du site
                </h2>
                <div className="space-y-2 text-soft-charcoal-secondary leading-relaxed">
                  <p>
                    <strong className="text-espresso">Nom commercial :</strong> Léger&apos;s Coffee
                  </p>
                  <p>
                    <strong className="text-espresso">Raison sociale :</strong> À compléter
                  </p>
                  <p>
                    <strong className="text-espresso">Forme juridique :</strong> À compléter
                  </p>
                  <p>
                    <strong className="text-espresso">Adresse du siège :</strong> Pl. des Augustins 19, 1205 Genève, Suisse
                  </p>
                  <p>
                    <strong className="text-espresso">Téléphone :</strong> +41 22 123 45 67
                  </p>
                  <p>
                    <strong className="text-espresso">Email :</strong> contact@legers-coffee.com
                  </p>
                  <p>
                    <strong className="text-espresso">Numéro d’immatriculation :</strong> À compléter
                  </p>
                  <p>
                    <strong className="text-espresso">Numéro TVA :</strong> À compléter
                  </p>
                  <p>
                    <strong className="text-espresso">Directeur de la publication :</strong> À compléter
                  </p>
                </div>
              </section>

              <section className="pt-8 border-t border-border-subtle">
                <h2 className="font-serif text-2xl text-espresso font-semibold mb-4">
                  2. Hébergement
                </h2>
                <div className="space-y-2 text-soft-charcoal-secondary leading-relaxed">
                  <p>
                    <strong className="text-espresso">Hébergeur :</strong> À compléter
                  </p>
                  <p>
                    <strong className="text-espresso">Adresse :</strong> À compléter
                  </p>
                  <p>
                    <strong className="text-espresso">Site web :</strong> À compléter
                  </p>
                </div>
              </section>

              <section className="pt-8 border-t border-border-subtle">
                <h2 className="font-serif text-2xl text-espresso font-semibold mb-4">
                  3. Accès au site
                </h2>
                <p className="text-soft-charcoal-secondary leading-relaxed">
                  Le site est accessible en principe 24h/24 et 7j/7, sauf interruption programmée ou non,
                  notamment pour les besoins de maintenance ou en cas de force majeure. Léger&apos;s Coffee
                  ne saurait être tenu responsable de toute indisponibilité, suspension ou interruption du site.
                </p>
              </section>

              <section className="pt-8 border-t border-border-subtle">
                <h2 className="font-serif text-2xl text-espresso font-semibold mb-4">
                  4. Propriété intellectuelle
                </h2>
                <p className="text-soft-charcoal-secondary leading-relaxed mb-4">
                  L’ensemble du contenu présent sur ce site, notamment les textes, images, photographies,
                  graphismes, logo, vidéos, icônes, illustrations, éléments visuels, structure et mise en page,
                  est protégé par les lois en vigueur sur la propriété intellectuelle.
                </p>
                <p className="text-soft-charcoal-secondary leading-relaxed">
                  Toute reproduction, représentation, diffusion, adaptation, modification ou exploitation,
                  totale ou partielle, de tout élément du site, par quelque procédé que ce soit, sans autorisation
                  préalable écrite de Léger&apos;s Coffee, est interdite.
                </p>
              </section>

              <section className="pt-8 border-t border-border-subtle">
                <h2 className="font-serif text-2xl text-espresso font-semibold mb-4">
                  5. Données personnelles
                </h2>
                <p className="text-soft-charcoal-secondary leading-relaxed mb-4">
                  Les informations recueillies via les formulaires du site, la création de compte, les commandes
                  ou les demandes de contact sont destinées à Léger&apos;s Coffee afin d’assurer la gestion
                  de la relation client, le traitement des commandes, le support et, le cas échéant,
                  l’envoi d’informations commerciales si vous y avez consenti.
                </p>
                <p className="text-soft-charcoal-secondary leading-relaxed mb-4">
                  Les données sont traitées de manière confidentielle et conservées pendant la durée nécessaire
                  aux finalités poursuivies, sous réserve des obligations légales applicables.
                </p>
                <p className="text-soft-charcoal-secondary leading-relaxed">
                  Vous pouvez demander l’accès, la rectification ou la suppression de vos données en écrivant à :
                  <span className="text-espresso font-medium"> contact@legers-coffee.com</span>.
                </p>
              </section>

              <section className="pt-8 border-t border-border-subtle">
                <h2 className="font-serif text-2xl text-espresso font-semibold mb-4">
                  6. Cookies
                </h2>
                <p className="text-soft-charcoal-secondary leading-relaxed">
                  Le site peut utiliser des cookies ou technologies similaires afin d’améliorer l’expérience
                  utilisateur, mesurer l’audience, assurer certaines fonctionnalités essentielles et optimiser
                  les performances du service. Vous pouvez configurer votre navigateur pour refuser tout ou partie
                  des cookies, sous réserve que cela puisse affecter certaines fonctionnalités du site.
                </p>
              </section>

              <section className="pt-8 border-t border-border-subtle">
                <h2 className="font-serif text-2xl text-espresso font-semibold mb-4">
                  7. Responsabilité
                </h2>
                <p className="text-soft-charcoal-secondary leading-relaxed mb-4">
                  Léger&apos;s Coffee s’efforce de fournir sur le site des informations aussi précises que possible.
                  Toutefois, des erreurs, omissions ou mises à jour tardives peuvent survenir.
                </p>
                <p className="text-soft-charcoal-secondary leading-relaxed">
                  L’utilisateur reconnaît utiliser les informations du site sous sa responsabilité exclusive.
                  Léger&apos;s Coffee ne pourra être tenu responsable des dommages directs ou indirects liés à
                  l’utilisation du site ou à l’impossibilité d’y accéder.
                </p>
              </section>

              <section className="pt-8 border-t border-border-subtle">
                <h2 className="font-serif text-2xl text-espresso font-semibold mb-4">
                  8. Liens externes
                </h2>
                <p className="text-soft-charcoal-secondary leading-relaxed">
                  Le site peut contenir des liens vers des sites tiers. Léger&apos;s Coffee n’exerce aucun contrôle
                  sur ces sites et décline toute responsabilité quant à leur contenu, leur politique de confidentialité
                  ou leur disponibilité.
                </p>
              </section>

              <section className="pt-8 border-t border-border-subtle">
                <h2 className="font-serif text-2xl text-espresso font-semibold mb-4">
                  9. Droit applicable
                </h2>
                <p className="text-soft-charcoal-secondary leading-relaxed">
                  Les présentes mentions légales sont soumises au droit applicable en Suisse.
                  En cas de litige, et à défaut de résolution amiable, les juridictions compétentes
                  seront celles du ressort compétent de Genève, sauf disposition légale impérative contraire.
                </p>
              </section>

              <section className="pt-8 border-t border-border-subtle">
                <h2 className="font-serif text-2xl text-espresso font-semibold mb-4">
                  10. Contact
                </h2>
                <p className="text-soft-charcoal-secondary leading-relaxed">
                  Pour toute question concernant le site ou son contenu, vous pouvez contacter Léger&apos;s Coffee
                  à l’adresse suivante :
                  <span className="text-espresso font-medium"> contact@legers-coffee.com</span>.
                </p>
              </section>

              <div className="pt-8 border-t border-border-subtle">
                <p className="text-sm text-soft-charcoal-secondary">
                  Dernière mise à jour : mars 2026
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}